import type { FC } from "react";
import { useCallback } from "react";

import type { TelephoneFieldValue } from "@jti/commerce-types";
import { useFormContext } from "@jti/ui";

import type { ShouldUseProfileDataFieldConfig } from "@checkout-v2/formFields";
import { CheckboxField } from "@checkout-v2/formFields";

export type RecipientCheckboxProps = {
  fieldConfig: ShouldUseProfileDataFieldConfig;
  firstNameSavedDefault: string;
  lastNameSavedDefault: string;
  telephoneSavedDefault: TelephoneFieldValue;
  telephoneDefaultValue: TelephoneFieldValue;
};

export const RecipientCheckbox: FC<RecipientCheckboxProps> = ({
  fieldConfig,
  firstNameSavedDefault,
  lastNameSavedDefault,
  telephoneSavedDefault,
  telephoneDefaultValue,
}) => {
  const form = useFormContext();

  const onToggle = useCallback(
    (checked: boolean) => {
      if (checked) {
        form.setValue("firstName", firstNameSavedDefault);
        form.setValue("lastName", lastNameSavedDefault);
        form.setValue("telephone", telephoneSavedDefault);
      } else {
        form.setValue("telephone", telephoneDefaultValue);
      }
      form.clearErrors();
    },
    [form, firstNameSavedDefault, lastNameSavedDefault, telephoneSavedDefault, telephoneDefaultValue]
  );

  return <CheckboxField fieldConfig={fieldConfig} dataTestId="shouldUseProfileDataCheckbox" onToggle={onToggle} />;
};
